import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-1',
  templateUrl: './1.component.html',
  styleUrls: ['./1.component.scss'],
})
export class VbList1Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
